import React from 'react';
import { Layering } from '@atlaskit/layering';
import { MinimizableModalProvider } from '../controllers/use-minimizable-modal/index.tsx';
import type { MinimizableModalProps } from '../types.tsx';
import { ModalContainer } from './modal-container/main.tsx';
import { ReParenter } from './reparenter/index.tsx';

export const MinimizableModal = ({
	children,
	Container = ModalContainer,
	initialView,
	onClose,
	view,
	onViewChange,
	displayMinimizableButtons,
}: MinimizableModalProps) => (
	<Layering isDisabled={false}>
		<MinimizableModalProvider
			initialView={initialView}
			onClose={onClose}
			view={view}
			onViewChange={onViewChange}
			displayMinimizableButtons={displayMinimizableButtons}
		>
			<ReParenter Parent={Container}>{children}</ReParenter>
		</MinimizableModalProvider>
	</Layering>
);
